export default "/assets/images/app-showcase-01.jpg?8721fddebdb401944892f3f74008de33";